export default {
  tabs: {
    balanceSheet: 'Cân Đối Kế Toán',
    incomeStatement: 'Kết Quả Kinh Doanh',
    cashFlowStatement: 'Lưu Chuyển Tiền Tệ',
    financialReport: 'Tải báo cáo tài chính',
  },
  timeTab: {
    quarterly: 'Theo Quý',
    yearly: 'Theo Năm',
  },
  quarterName: 'Q%{quarter} %{year}',
  yearName: '%{year}',

  item: 'Chỉ Tiêu',
  trend: 'Xu Hướng',
  currentAssetsTooltip: 'TÀI SẢN NGẮN HẠN: %{tooltipValue} (%{percent}%)',
  tangibleFixedAssetsTooltip:
    'GTCL TSCĐ hữu hình: %{tooltipValue} (%{percent}%)',
  intangibleFixedAssetsTooltip:
    'GTCL tài sản cố định vô hình: %{tooltipValue} (%{percent}%)',
  intagibleFixedAssetsTooltip:
    'GTCL tài sản cố định vô hình: %{tooltipValue} (%{percent}%)',
  otherAssetsTooltip: 'Tài sản khác: %{tooltipValue} (%{percent}%)',

  currentLiabilitiesTooltip: 'Nợ ngắn hạn: %{tooltipValue} (%{percent}%)',
  longTermLiabilitiesTooltip: 'Nợ dài hạn: %{tooltipValue} (%{percent}%)',
  longtermLiabilitesTooltip: 'Nợ dài hạn: %{tooltipValue} (%{percent}%)',
  shareholderEquityTooltip: 'VỐN CHỦ SỞ HỮU: %{tooltipValue} (%{percent}%)',
  minorityInterestTooltip:
    'LỢI ÍCH CỦA CỔ ĐÔNG THIỂU SỐ: %{tooltipValue} (%{percent}%)',
  minorityInterestBeforeTooltip:
    'LỢI ÍCH CỦA CỔ ĐÔNG THIỂU SỐ: %{tooltipValue} (%{percent}%)',

  placementsLoanToCreditInstitutionsTooltip:
    'Tiền gửi tại các TCTD khác và cho vay các TCTD khác: %{tooltipValue} (%{percent}%)',
  loansAdvancesToCustomersTooltip:
    'Cho vay khách hàng: %{tooltipValue} (%{percent}%)',
  loansAndAdvancesToCustomersOneTooltip:
    'Cho vay khách hàng: %{tooltipValue} (%{percent}%)',
  investmentSecuritiesTooltip:
    'Chứng khoán đầu tư: %{tooltipValue} (%{percent}%)',

  depositsFromCustomersTooltip:
    'Tiền gửi của khách hàng: %{tooltipValue} (%{percent}%)',
  otherLiabilitiesTooltip: 'Các khoản nợ khác: %{tooltipValue} (%{percent}%)',
  otherLiabilitesTooltip: 'Các khoản nợ khác: %{tooltipValue} (%{percent}%)',
  shareholdersEquityTooltip: 'Vốn chủ sở hữu: %{tooltipValue} (%{percent}%)',

  totalAssets: 'TỔNG TÀI SẢN',
  currentAssets: 'TÀI SẢN NGẮN HẠN',

  cashAndCashEquivalents: 'Tiền và tương đương tiền',
  cash: 'Tiền',
  cashEquivalents: 'Các khoản tương đương tiền',

  shortTermInvestment: 'Giá trị thuần đầu tư ngắn hạn',
  shortTermInvestmentChild: 'Đầu tư ngắn hạn',
  provisionForDiminution: 'Dự phòng đầu tư ngắn hạn',
  heldToMaturityInvestment: 'Đầu tư nắm giữ đến ngày đáo hạn',

  accountReceivable: 'Các khoản phải thu',
  tradeAccountReceivable: 'Phải thu khách hàng',
  prepaymentsToSuppliers: 'Trả trước người bán',
  interCompanyReceivables: 'Phải thu nội bộ',
  constructionContractInProgressReceivables: 'Phải thu về XDCB',
  shortTermLoansReceivables: 'Phải thu về cho vay ngắn hạn',
  otherReceivables: 'Phải thu khác',
  provisionForDoubtfulDebts: 'Dự phòng nợ khó đòi',
  shortageOfCurrentAssetsWaitingForSolution: 'Tài sản thiếu chờ xử lý',

  inventories: 'Hàng tồn kho, ròng',
  inventoriesChild: 'Hàng tồn kho',
  provisionForDeclineInInventories: 'Dự phòng giảm giá HTK',

  otherCurrentAssets: 'Tài sản lưu động khác',
  shortTermPrepaidExpenses: 'Trả trước ngắn hạn',
  VATToBeClaimed: 'Thuế VAT phải thu',
  otherTaxesReceivable: 'Phải thu thuế khác',
  governmentBondsPurchasedForResale:
    'Giao dịch mua bán lại trái phiếu chính phủ',
  otherCurrentAssetsChild: 'Tài sản lưu động khác',

  longTermAssets: 'TÀI SẢN DÀI HẠN',

  longTermTradeReceivables: 'Phải thu dài hạn',
  longTermTradeReceivablesFromCustomers: 'Phải thu khách hàng dài hạn',
  longTermPrepaymentsToSuppliers: 'Trả trước người bán dài hạn',
  paidInCapitalInWhollyOwnedSubsidiaries:
    'Vốn kinh doanh ở các đơn vị trực thuộc',
  longTermInterCompanyReceivables: 'Phải thu nội bộ dài hạn',
  longTermLoansReceivables: 'Phải thu về cho vay dài hạn',
  otherLongTermReceivables: 'Phải thu dài hạn khác',
  provisionForDoubtfulLTReceivable: 'Dự phòng phải thu dài hạn',

  fixedAssets: 'Tài sản cố định',
  tangibleFixedAssets: 'GTCL TSCĐ hữu hình',
  tangibleFixedAssetsCost: 'Nguyên giá TSCĐ hữu hình',
  tangibleFixedAssetsAccumulatedDepreciation: 'Khấu hao lũy kế TSCĐ hữu hình',
  financeLeaseAssets: 'GTCL Tài sản thuê tài chính',
  financeLeaseAssetsCost: 'Nguyên giá tài sản thuê tài chính',
  financeLeaseAssetsAccumulatedDepreciation:
    'Khấu hao lũy kế tài sản thuê tài chính',
  intangibleFixedAssets: 'GTCL tài sản cố định vô hình',
  intangibleFixedAssetsCost: 'Nguyên giá TSCĐ vô hình',
  intangibleFixedAssetsAccumulatedDepreciation: 'Khấu khao lũy kế TSCĐ vô hình',

  investmentProperties: 'Giá trị ròng tài sản đầu tư',
  investmentPropertiesCost: 'Nguyên giá tài sản đầu tư',
  investmentPropertiesAccumulatedDepreciation: 'Khấu hao lũy kế tài sản đầu tư',

  longTermIncompleteAssets: 'Tài sản dở dang dài hạn',
  longTermCostOfWorkInProgress: 'Chi phí sản xuất, kinh doanh dở dang dài hạn',
  constructionInProgress: 'Xây dựng cơ bản dở dang',

  longTermInvestments: 'Đầu tư dài hạn',
  investmentsInSubsidiaries: 'Đầu tư vào các công ty con',
  investmentsInAssociates: 'Đầu tư vào các công ty liên kết',
  otherLongTermInvestments: 'Đầu tư dài hạn khác',
  provisionForLongTermInvestments: 'Dự phòng giảm giá đầu tư dài hạn',
  longTermInvestmentsHeldToMaturityInvestment:
    'Đầu tư nắm giữ đến ngày đáo hạn',
  goodWillBefore: 'Lợi thế thương mại (trước 2015)',
  otherLongTermAssets: 'Tài sản dài hạn khác',
  longTermPrepayments: 'Trả trước dài hạn',
  deferredIncomeTaxAssets: 'Thuế thu nhập hoãn lại phải thu',
  longTermEquipmentAndMaterialAndSpareParts:
    'Thiết bị, vật tư, phụ tùng thay thế dài hạn',
  otherLongTermAssetsChild: 'Các tài sản dài hạn khác',
  goodWill: 'Lợi thế thương mại',

  liabilities: 'NỢ PHẢI TRẢ',

  currentLiabilities: 'Nợ ngắn hạn',
  tradeAccountsPayable: 'Phải trả người bán',
  advancesFromCustomers: 'Người mua trả tiền trước',
  taxesAndOtherPayableToStateBudget: 'Thuế và các khoản phải trả Nhà nước',
  payableToEmployees: 'Phải trả người lao động',
  accruedExpenses: 'Chi phí phải trả',
  interCompanyPayable: 'Phải trả nội bộ',
  constructionContractInProgressPayable: 'Phải trả về xây dựng cơ bản',
  shortTermUnrealizedRevenue: 'Doanh thu chưa thực hiện ngắn hạn',
  otherPayable: 'Phải trả khác',
  shortTermBorrowings: 'Vay ngắn hạn',
  provisionForSTLiabilities: 'Dự phòng các khoản phải trả ngắn hạn',
  bonusAndWelfareFunds: 'Quỹ khen thưởng, phúc lợi',
  priceStabilizationFund: 'Quỹ bình ổn giá',
  currentLiabilitiesGovernmentBondsPurchasedForResale:
    'Giao dịch mua bán lại trái phiếu chính phủ',

  longTermLiabilities: 'Nợ dài hạn',
  longTermTradePayable: 'Phải trả nhà cung cấp dài hạn',
  longTermAdvancesFromCustomers: 'Người mua trả tiền trước dài hạn',
  longTermAccruedExpenses: 'Chi phí phải trả dài hạn',
  intraCompanyPayablesForOperatingCapitalReceived:
    'Phải trả nội bộ về vốn kinh doanh',
  longTermInterCompanyPayable: 'Phải trả nội bộ dài hạn',
  unrealizedRevenue: 'Doanh thu chưa thực hiên',
  otherLongTermPayable: 'Phải trả dài hạn khác',
  longTermBorrowings: 'Vay dài hạn',
  convertibleBonds: 'Trái phiếu chuyển đổi',
  longTermLiabilitiesPreferredShares: 'Cổ phiếu ưu đãi',
  preferredShares: 'Cổ phiếu ưu đãi',
  deferredIncomeTaxLiabilities: 'Thuế thu nhập hoãn lại phải trả',
  provisionForSeveranceAllowances: 'Dự phòng trợ cấp thôi việc',
  provisionForLongTermLiabilities: 'Dự phòng các khoản công nợ dài hạn',
  technologyScienceDevelopmentFund: 'Quỹ phát triển khoa học công nghệ',

  ownerEquity: 'VỐN CHỦ SỞ HỮU',

  capitalAndReserves: 'Vốn và các quỹ',
  paidInCapital: 'Vốn góp',
  commonShares: 'Cổ phiếu phổ thông',
  sharePremium: 'Thặng dư vốn cổ phần',
  conversionOptionsOnConvertibleBonds: 'Quyền chọn chuyển đổi trái phiếu',
  ownerOtherCapital: 'Vốn khác',
  treasuryShares: 'Cổ phiếu quỹ',
  differencesUponAssetRevaluation: 'Chênh lệch đánh giá lại tài sản',
  foreignExchangeDifferences: 'Chênh lệch tỷ giá',
  investmentAndDevelopmentFunds: 'Quỹ đầu tư và phát triển',
  enterpriseArrangementFund: 'Quỹ hỗ trợ sắp xếp doanh nghiệp',
  financialReserveFunds: 'Quỹ dự phòng tài chính',
  otherFunds: 'Quỹ khác',
  undistributedEarnings: 'Lãi chưa phân phối',
  beginningAccumulatedUndistributedEarnings:
    'LNST chưa phân phối lũy kế đến cuối kỳ trước',
  currentPeriodUndistributedEarnings: 'LNST chưa phân phối kỳ này',
  capitalAndReservesMinorityInterests: 'Lợi ích cổ đông không kiểm soát',

  budgetSourcesAndFunds: 'Vốn Ngân sách nhà nước và quỹ khác',

  bonusAndWelfareFundsBefore2010: 'Quỹ khen thưởng, phúc lợi (trước 2010)',
  budgetSourcesAndOtherFundsBefore2010: 'Vốn ngân sách nhà nước',
  fundsUsedForFixedAssetAcquisitions: 'Nguồn kinh phí đã hình thành TSCĐ',

  minorityInterest: 'LỢI ÍCH CỦA CỔ ĐÔNG THIỂU SỐ',

  totalResources: 'TỔNG CỘNG NGUỒN VỐN',

  sales: 'Doanh số',
  salesDeductions: 'Các khoản giảm trừ',
  netSales: 'Doanh số thuần',
  costOfSales: 'Giá vốn hàng bán',
  grossProfit: 'Lãi gộp',
  financialIncome: 'Thu nhập tài chính',
  financialExpenses: 'Chi phí tài chính',
  ofWhichInterestExpenses: 'Trong đó: Chi phí lãi vay',
  GainLossFromJointVenturesFrom2015: 'Lãi/(lỗ) từ công ty liên doanh',
  sellingExpenses: 'Chi phí bán hàng',
  generalAndAdminExpenses: 'Chi phí quản lý doanh  nghiệp',

  operatingProfitLoss: 'Lãi/(lỗ) từ hoạt động kinh doanh',
  otherIncomes: 'Thu nhập khác',
  otherExpenses: 'Chi phí khác',

  netOtherIncomeExpenses: 'Thu nhập khác, ròng',
  incomeFromInvestmentsInOtherEntities:
    'Lãi/(lỗ) từ công ty liên doanh (trước năm 2015)',

  netAccountingProfitLossBeforeTax: 'Lãi/(lỗ) ròng trước thuế',
  corporateIncomeTaxCurrent: 'Thuế thu nhập doanh nghiệp – hiện thời',
  corporateIncomeTaxDeferred: 'Thuế thu nhập doanh nghiệp – hoãn lại',

  corporateIncomeTaxExpenses: 'Chi phí thuế thu nhập doanh nghiệp',
  netProfitLossAfterTax: 'Lãi/(lỗ) thuần sau thuế',
  minorityInterests: 'Lợi ích của cổ đông thiểu số',
  attributableToParentCompany: 'Lợi nhuận của Cổ đông của Công ty mẹ',
  EPSBasis: 'Lãi cơ bản trên cổ phiếu (VND)',
  EPSDiluted: 'Lãi trên cổ phiếu pha loãng (VND)',
  ebit: 'EBIT',
  ebitDa: 'EBITDA',
  cashAndPreciousMetals: 'Tiền mặt, vàng bạc, đá quý',
  balancesWithTheSBV: 'Tiền gửi tại Ngân hàng nhà nước Việt Nam',
  placementsWithAndLoansToOtherCreditInstitutions:
    'Tiền gửi tại các TCTD khác và cho vay các TCTD khác',

  tradingSecuritiesNet: 'Chứng khoán kinh doanh',
  tradingSecurities: 'Chứng khoán kinh doanh',
  lessProvisionForDiminutionInValueOfTradingSecurities:
    'Dự phòng giảm giá chứng khoán kinh doanh',

  derivativesAndOtherFinancialAssets:
    'Các công cụ tài chính phái sinh và các tài sản tài chính khác',
  loansAndAdvancesToCustomersNet: 'Cho vay khách hàng',
  loansAndAdvancesToCustomersOne: 'CHO VAY VÀ ỨNG TRƯỚC CHO VAY ',
  loansAndAdvancesToCustomers: 'Cho vay khách hàng',
  lessProvisionForLossesOnLoansAndAdvancesToCustomers:
    'Dự phòng rủi ro cho vay khách hàng',

  investmentSecurities: 'Chứng khoán đầu tư',
  availableForSalesSecurities: 'Chứng khoán đầu tư sẵn sàng để bán',
  heldToMaturitySecurities: 'Chứng khoán đầu tư giữ đến ngày đáo hạn',
  lessProvisionForDiminutionInValueOfInvestmentSecurities:
    'Dự phòng giảm giá chứng khoán đầu tư',

  investmentInOtherEntitiesAndLongTermInvestments: 'Góp vốn, đầu tư dài hạn',
  investmentInJointVentures: 'Đầu tư vào công ty con',
  investmentInAssociateCompanies: 'Đầu tư vào công ty liên doanh',

  financeLeasedAssets: 'Tài sản cố định thuê tài chính',

  otherAssets: 'Tài sản Có khác',

  liabilitiesAndShareholderEquity: 'NỢ PHẢI TRẢ VÀ VỐN CHỦ SỞ HỮU',

  totalLiabilities: 'Tổng nợ phải trả',
  dueToGovAndBorrowingsFromSBV: 'Các khoản nợ chính phủ và NHNN Việt Nam',
  depositsAndBorrowingsFromOtherCreditInstitutions:
    'Tiền gửi và vay các Tổ chức tín dụng khác',
  depositsFromCustomers: 'Tiền gửi của khách hàng',
  derivativesAndOtherFinancialLiabilities:
    'Các công cụ tài chính phái sinh và các khoản nợ tài chính khác',
  fundsReceivedFromGovInternationalAndOtherInstitutions:
    'Vốn tài trợ, uỷ thác đầu tư của Chính phủ và các tổ chức tín dụng khác',
  convertibleBondsCDsAndOtherValuablePapersIssued: 'Phát hành giấy tờ có giá',
  otherLiabilities: 'Các khoản nợ khác',

  shareholderEquity: 'Vốn chủ sở hữu',
  capital: 'Vốn của tổ chức tín dụng',
  charterCapital: 'Vốn điều lệ',
  fundForBasicConstruction: 'Vốn đầu tư XDCB',
  otherCapitals: 'Vốn khác',
  reserves: 'Quỹ của tổ chức tín dụng',
  differenceUponAssetsRevaluation: 'Chênh lệch đánh giá lại tài sản',
  foreignCurrencyDifferenceReserve: 'Chênh lệch tỷ giá hối đoái',
  retainedEarnings: 'Lợi nhuận chưa phân phối',

  chartTitle: {
    currentAssets: 'TÀI SẢN NGẮN HẠN',
    tangibleFixedAssets: 'GTCL TSCĐ hữu hình',
    intangibleFixedAssets: 'GTCL tài sản cố định vô hình',
    otherAssets: 'Tài sản khác',
    currentLiabilities: 'Nợ ngắn hạn',
    longTermLiabilities: 'Nợ dài hạn',
    shareholdersEquity: 'VỐN CHỦ SỞ HỮU',
    minorityInterest: 'LỢI ÍCH CỦA CỔ ĐÔNG THIỂU SỐ',
    minorityInterestBefore: 'LỢI ÍCH CỦA CỔ ĐÔNG THIỂU SỐ (trước 2015)',
    placementsLoanToCreditInstitutions:
      'Tiền gửi tại các TCTD khác và cho vay các TCTD khác',
    loansAdvancesToCustomers: 'Cho vay khách hàng',
    investmentSecurities: 'Chứng khoán đầu tư',
    depositsFromCustomers: 'Tiền gửi của khách hàng',
    otherLiabilities: 'Các khoản nợ khác',
  },

  incomeStatementChart: {
    revenue: 'DOANH THU',
    operatingProfit: 'LỢI NHUẬN TỪ HOẠT ĐỘNG KINH DOANH',
    netProfit: 'LỢI NHUẬN THUẦN',
    netProfitMargin: 'BIÊN LỢI NHUẬN THUẦN',
    profitAndLoss: 'LÃI VÀ LỖ',

    revenueTooltip: 'Doanh số: %{tooltipValue} Tỷ VND',
    operatingProfitTooltip:
      'Lãi/(lỗ) từ hoạt động kinh doanh: %{tooltipValue} Tỷ VND',
    netProfitTooltip: 'Lãi/(lỗ) thuần sau thuế: %{tooltipValue} Tỷ VND',
    netProfitMarginTooltip: 'Tỷ suất lợi nhuận thuần (TTM)%: %{tooltipValue} %',

    netInterestIncome: 'Thu nhập lãi thuần',
    netFeeAndCommissionIncome: 'Lãi thuần từ hoạt động dịch vụ',
    operatingIncome: 'Tổng thu nhập hoạt động',
    provisionForCreditLoses: 'Chi phí dự phòng rủi ro tín dụng',
    netProfitAfterTax: 'Lợi nhuận sau thuế',
    netRevenueOfInsurancePremiumTooltip:
      'Doanh thu phí bảo hiểm thuần : %{tooltipValue} Tỷ. VND',
    netOperatingProfitFromInsuranceOperationTooltip:
      'Lợi nhuận thuần hoạt động kinh doanh bảo hiểm : %{tooltipValue} Tỷ VND',

    netInterestIncomeTooltip: 'Thu nhập lãi thuần: %{tooltipValue} Tỷ VND',
    netFeeAndCommissionIncomeTooltip:
      'Lãi thuần từ hoạt động dịch vụ: %{tooltipValue} Tỷ VND',
    operatingIncomeTooltip: 'Tổng thu nhập hoạt động: %{tooltipValue} Tỷ VND',
    provisionForCreditLosesTooltip:
      'Chi phí dự phòng rủi ro tín dụng: %{tooltipValue} Tỷ VND',
    netProfitAfterTaxTooltip: 'Lợi nhuận sau thuế: %{tooltipValue} Tỷ VND',
  },

  netCashInflowsFromOperatingActivities:
    'Lưu chuyển tiền tệ ròng từ các hoạt động sản xuất kinh doanh',
  operatingProfitLossBeforeChangesInWorkingCapital:
    'Lãi/(lỗ) trước những thay đổi vốn lưu động',
  netProfitBeforeTax: 'Lãi trước thuế',
  depreciationAndAmortisation: 'Khấu hao TSCĐ',
  amortisationOfGoodwill: 'Phân bổ lợi thế thương mại',
  provisions: 'Chi phí dự phòng',
  unrealisedForeignExchangeGainLoss:
    'Lãi/(lỗ) chênh lệch tỷ giá chưa thực hiện',
  profitLossFromLiquidatingFixedAssets: 'Lãi/(lỗ) từ thanh lý tài sản cố định',
  profitLossFromInvestingActivities: 'Lãi/(lỗ) từ hoạt động đầu tư',
  interestExpense: 'Chi phí lãi vay',
  interestIncomeAndDividend: 'Thu lãi và cổ tức',
  otherAdjustments: 'Các khoản điều chỉnh khác',
  increaseDecreaseInReceivables: '(Tăng)/giảm các khoản phải thu',
  increaseDecreaseInventories: '(Tăng)/giảm hàng tồn kho',
  increaseDecreasePayable: 'Tăng/(giảm) các khoản phải trả',
  increaseDecreasePrepaidExpenses: '( Tăng)/giảm chi phí trả trước',
  increaseDecreaseTradingSecurities: '(Tăng)/giảm chứng khoán kinh doanh',
  interestPaid: 'Chi phí lãi vay đã trả',
  corporateIncomeTaxPaid: 'Thuế thu nhập doanh nghiệp đã trả',
  otherReceiptsFromOperatingActivities:
    'Tiền thu khác từ các hoạt động kinh doanh',
  otherPaymentsOnOperatingActivities:
    'Tiền chi khác từ các hoạt động kinh doanh',

  netCashInflowsOutflowsFromInvestingActivities:
    'Lưu chuyển tiền tệ ròng từ hoạt động đầu tư',
  purchasesOfFixedAssetsAndOtherLongTermAssets:
    'Tiền mua tài sản cố định và các tài sản dài hạn khác',
  proceedsFromDisposalOfFixedAssets:
    'Tiền thu được từ thanh lý tài sản cố định',
  loansGrantedPurchasesOfDebtInstruments: 'Tiền cho vay hoặc mua công cụ nợ',
  collectionOfLoansProceedsFromSalesOfDebtsInstruments:
    'Tiền thu từ cho vay hoặc thu từ phát hành công cụ nợ',
  investmentsInOtherEntities: 'Đầu tư vào các doanh nghiệp khác',
  proceedsFromDivestmentInOtherEntities:
    'Tiền thu từ việc bán các khoản đầu tư vào các doanh nghiệp khác',
  dividendsAndInterestReceived: 'Cổ tức và tiền lãi nhận được',

  netCashInflowsOutflowsFromFinancingActivities:
    'Lưu chuyển tiền tệ từ hoạt động tài chính',
  proceedsFromIssueOfShares: 'Tiền thu từ phát hành cổ phiếu và vốn góp',
  paymentsForShareReturnsAndRepurchases:
    'Chi trả cho việc mua lại, trả lại cổ phiếu',
  proceedsFromBorrowings: 'Tiền thu được các khoản đi vay',
  repaymentOfBorrowings: 'Tiển trả các khoản đi vay',
  financeLeasePrincipalPayments: 'Tiền thanh toán vốn gốc đi thuê tài chính',
  dividendsPaid: 'Cổ tức đã trả',
  interestsDividendsProfitsReceived: 'Tiền lãi đã nhận',

  netIncreaseInCashAndCashEquivalents: 'Lưu chuyển tiền thuần trong kỳ',
  cashAndCashEquivalentsAtTheBeginningOPeriod:
    'Tiền và tương đương tiền đầu kỳ',
  effectOfForeignExchangeDifferences: 'Ảnh hưởng của chênh lệch tỷ giá',
  cashAndCashEquivalentsAtTheEndOfPeriod: 'Tiền và tương đương tiền cuối kỳ',

  //banking
  netCashFromOperatingActivities:
    'Lưu chuyển tiền thuần từ các hoạt động sản xuất kinh doanh',
  netCashFlowsFromOperatingActivitiesBeforeBIT:
    'Lưu chuyển tiền thuần từ hoạt động kinh doanh trước thuế thu nhập DN',
  interestAndSimilarReceipts: 'Thu nhập lãi và các khoản tương đương',
  interestAndSimilarPayments: 'Chi phí lãi và các khoản tương đương',
  feesAndCommissionIncomeReceived: 'Thu nhập từ hoạt động dịch vụ nhận được',
  netReceiptsFromDealingOfForeignCurrenciesGold:
    'Thu nhập thuần từ hoạt động kinh doanh ngoại hối và vàng',
  netReceiptsFromDealingOfSecurities:
    'Thu nhập từ hoạt động kinh doanh chứng khoán',
  otherOperatingIncome: 'Thu nhập khác',
  receiptsFromDebtsWrittenOffOrPaidOffByRiskFund:
    'Tiền thu các khoản nợ đã được xử lý, xóa, bù đắp bằng nguồn rủi ro',
  paymentsToEmployeesAndOtherOperatingExpenses:
    'Thanh toán cho nhân viên và nhà cung cấp',
  paymentsForCorporateIncomeTax: 'Tiền chi nộp thuế thu nhập doanh nghiệp',
  increaseDecreaseInCompulsoryReservesWithTheSBV: 'Tiền gửi tại NHNN',
  increaseDecreaseInPlacementsWithAndLoansToOtherCreditInstitutions:
    '(Tăng)/Giảm các khoản tiền gửi và cho vay các tổ chức tín dụng khác',
  increaseDecreaseInTradingSecurities:
    '(Tăng)/giảm các khoản về kinh doanh chứng khoán',
  increaseDecreaseInDerivativesAndOtherFinancialAssets:
    '(Tăng)/Giảm các công cụ tài chính phái sinh và các tài sản tài chính khác',
  increaseDecreaseInLoansAndAdvancesToCustomers:
    '(Tăng)/Giảm các khoản cho vay khách hàng',
  increaseDecreaseInInterestReceivable: '(Tăng)/Giảm lãi, phí phải thu',
  increaseDecreaseInProvisionForLoanLosses:
    'Tăng/(Giảm) nguồn dự phòng để bù đắp tổn thất các khoản',
  increaseDecreaseInOtherOperatingAssets:
    '(Tăng)/Giảm khác về tài sản hoạt động',
  increaseDecreaseInBorrowingsFromTheStateAndSbv:
    'Tăng/(Giảm) các khoản nợ chính phủ và NHNN',
  increaseDecreaseInPlacementsAndBorrowingsFromOtherCreditInstitutions:
    'Tăng/(Giảm) các khoản tiền gửi và vay các TCTD khác',
  increaseDecreaseInDepositsFromCustomers:
    'Tăng/(Giảm) tiền gửi của khách hàng',
  increaseDecreaseInDerivativesAndOtherFinancialLiabilities:
    'Tăng/(Giảm) các công cụ tài chính phái sinh và các khoản nợ tài chính khác',
  increaseDecreaseInFundsReceivedFromGovInternationalAndOtherInstitutions:
    'Tăng/(Giảm) vốn tài trợ, uỷ thác đầu tư của chính phủ và các TCTD khác',
  increaseDecreaseInValuablePapersIssued:
    'Tăng/(Giảm) phát hành giấy tờ có giá',
  increaseDecreaseInAccruedInterestExpenses: 'Tăng/(Giảm) lãi, phí phải trả',
  increaseDecreaseInOtherOperatingLiabilities:
    'Tăng/(Giảm) khác về công nợ hoạt động',
  paymentFromReserves: 'Chi từ các quỹ của TCTD',
  badDebtRecoveries: 'Thu được từ nợ khó đòi',

  netCashFromInvestingActivities: 'Lưu chuyển tiền thuần từ hoạt động đầu tư',
  paymentsOnDisposalOfFixedAssets: 'Tiền chi từ thanh lý, nhượng bán TSCĐ',
  purchasesOfInvestmentProperties: 'Mua sắm Bất động sản đầu tư',
  proceedsFromDisposalOfInvestmentProperties:
    'Tiền thu từ bán, thanh lý bất động sản đầu tư',
  paymentsOnDisposalOfInvestmentProperties:
    'Tiền chi ra do bán, thanh lý bất động sản đầu tư',

  netCashFromFinancingActivities: 'Lưu chuyển tiền từ hoạt động tài chính',
  proceedsFromIssuanceOfConvertibleBonds:
    'Tiền thu từ phát hành giấy tờ có giá dài hạn đủ điều kiện tính vào vốn tự có và các khoản vốn vay dài hạn khác',
  paymentsForRedemptionOfConvertibleBonds:
    'Tiền chi thanh toán giấy tờ có giá dài hạn đủ điều kiện tính vào vốn tự có và các khoản vốn vay dài hạn khác',
  purchaseOfTreasuryShares: 'Tiền chi ra mua cổ phiếu quỹ',
  proceedsFromSellingOfTreasuryShares: 'Tiền thu được do bán cổ phiếu quỹ',

  netIncreaseDecreaseInCashAndCashEquivalents: 'Lưu chuyển tiền thuần trong kỳ',
  cashAndCashEquivalentsAtTheBeginningOfPeriod:
    'Tiền và tương đương tiền đầu kỳ',

  cashFlowStatementChart: {
    CFFromOperating: 'Tiền thuần từ hoạt động kinh doanh',
    CFFromInvesting: 'Tiền thuần từ hoạt động đầu tư ',
    CFFromFinancing: 'Tiền thuần từ hoạt động tài chính',
    cashEquivalentsEnding: 'Tiền và tương đương tiền cuối kỳ',
    chartTitle: 'DÒNG TIỀN',

    CFFromOperatingTooltip:
      'Tiền thuần từ hoạt động kinh doanh: %{tooltipValue} Tỷ VND',
    CFFromInvestingTooltip:
      'Tiền thuần từ hoạt động đầu tư: %{tooltipValue} Tỷ VND',
    CFFromFinancingTooltip:
      'Tiền thuần từ hoạt động tài chính: %{tooltipValue} Tỷ VND',
    cashEquivalentsEndingTooltip:
      'Tiền và tương đương tiền cuối kỳ: %{tooltipValue} Tỷ VND',
  },

  interestAndSimilarIncome: 'Thu nhập lãi và các khoản thu nhập tương tự',
  interestAndSimilarExpenses: 'Chi phí lãi và các chi phí tương tự',

  netInterestIncome: 'Thu nhập lãi thuần',
  feesAndCommissionIncome: 'Thu nhập từ hoạt động dịch vụ',
  feesAndCommissionExpenses: 'chi phí hoạt động dịch vụ',
  netFeeAndCommissionIncome: 'Lãi thuần từ hoạt động dịch vụ',
  netGainLossFromForeignCurrencyAndGoldDealings:
    'Lãi/(lỗ) thuần từ hoạy động kinh doanh ngoại hối và vàng',
  netGainLossFromTradingOfTradingSecurities:
    'Lãi/(lỗ) thuần từ mua bán chứng khoán kinh doanh',
  netGainLossFromDisposalOfInvestmentSecurities:
    'Lãi/(lỗ) thuần từ mua bán chứng khoán đầu tư',
  dividendsIncome: 'Thu nhập từ góp vốn, mua cổ phần',
  totalOperatingIncome: 'Tổng thu nhập hoạt động',
  operatingProfitBeforeProvisionForCreditLosses:
    'LN thuần từ hoạt động kinh doanh trước CF dự phòng rủi ro tín dụng',
  provisionForCreditLosses: 'Chi phí dự phòng rủi ro tín dụng',
  profitBeforeTax: 'Tổng lợi nhuận trước thuế',
  corporateIncomeTax: 'Chi phí thuế thu nhập doanh nghiệp',
  netProfitForTheYear: 'Lợi nhuận sau thuế',
  basicEarningsPerShareForProfitAttributableToTheEquityHolders:
    'Lãi cơ bản trên cổ phiếu (VND)',
  yAxisLeftChartTitle: 'Tỷ VND',
  yAxisRightChartTitle: 'Tỷ VND',

  // insurance income statement
  revenueFromInsurancePremium: 'Doanh thu phí bảo hiểm',
  grossWrittenPremium: 'Thu phí bảo hiểm ',
  reinsurancePremiumAssumned: 'Thu phí nhận tái bảo hiểm ',
  increaseDecreaseInUnearnedPremiumReserveForDirectInsuranceAndOutwardReinsurance:
    'Tăng/giảm dự phòng phí bảo hiểm ',
  deductions: 'Phí nhượng tại bảo hiểm ',
  reinsurancePremiumCeded: 'Tổng phí nhượng tái bảo hiểm ',
  increaseDecreaseInReinsurancePremiumCededReserve:
    'Tăng/giảm dự phòng phí nhượng bảo hiểm ',
  premiumDeductions: 'Giảm phí',
  premiumReturns: 'Hoàn phí',
  otherDeductions: 'Các khoản giảm từ khác',
  netRevenueOfInsurancePremium: 'Doanh thu phí bảo hiểm thuần ',
  increaseInUnearnedPremiumReserveAndTechinicalReserve:
    'Tăng do dự phòng phí chưa được hưởng và dự phòng toán học (trước 2014)',
  commissionIncomeFromOutwardReinsuranceAndOtherIncomeFromInsuranceActivities:
    'Hoa hồng nhượng tái bảo hiểm và doanh thu HĐKD bảo hiểm ',
  commissionOnReinsuranceCeded: 'Thu hoa hồng nhượng tái bảo hiểm ',
  otherIncome: 'Thu nhập khác hoạt động kinh doanh bảo hiểm ',
  incomeOnReinsuranceAssumed: 'Thu khác nhận tái bảo hiểm ',
  incomeOnReinsuranceCeded: 'Thu khác nhượng tái bảo hiểm ',
  incomeFromOtherAcitvites: 'Thu họat động khác ',
  netSalesFromInsuranceBusiness:
    'Doanh thu thuần từ hoạt động kinh doanh bảo hiểm ',
  claimExpense: 'Chi bồi thường',
  totalClaimExpense: 'Tổng chi bồi thường',
  claimAndMaturityPaymentExpenses:
    'Chi bồi thường bảo hiểm gốc và chi trả đáo hạn ',
  claimExpensesForReinsuranceAssumed: 'Chi bồi thường nhận tái bảo hiểm ',
  claimExpenseDeductions: 'Các khoản giảm từ chi phí',
  recoveriesFormReinsuranceCeded:
    'Thu bồi thường nhượng tái bảo hiểm (Trước 2014)',
  subrogationRecoveries: 'Thu đòi người thứ ba',
  salvages: 'Thu xử lý hàng bồi thường 100%',
  claimRecoveriesFromOutwardReinsurance:
    'Thu bồi thường nhượng tái bảo hiểm (Trước 2014)',
  claimExpensesOnRetainedRisks: 'Bồi thường thuộc trách nhiệm giữ lại',
  increaseDecreaseInMathematicReserves: 'Tăng/giảm dự phòng toán học',
  increaseDecreaseInClaimReserve: 'Tăng/giảm dự phòng bồi thường',
  increaseDecreaseInClaimReserveForDirectInsuranceAndInwardInsurance:
    'Tăng/giảm dự phòng bồi thường bảo hiểm gốc và nhận tái bảo hiểm ',
  increaseDecreaseInClaimReserveForOutwardInsurance:
    'Tăng/giảm dự phòng bồi thường nhượng tái bảo hiểm ',
  totalInsuranceClaimSettlementExpenses: 'Tổng chi bồi thường bảo hiểm ',
  claimExpensesUsingCatastropheReserve: 'Chi bồi thường tư quỹ dao động lớn ',
  provisionForCatastropheReserve: 'Trích dự phòng dao động lớn',
  otherInsuranceOperatingExpenses: 'Chi khác hoạt động kinh doanh bảo hiểm ',
  otherUnderwritingExpenses: 'Chi khác hoạt động bảo hiểm gốc',
  commissions: 'Chi hoa hồng bảo hiểm gốc',
  expenseOfRecourseAgainstTheThirdParty: 'Chi đòi người thứ ba',
  expenseOfHandlingFullyIndemnifiedGoods: 'Chi xử lý hàng bồi thường 100%',
  riskMinimizationExpenses: 'Chi đề phòng hạn chế tổn thất',
  lossAdjustingFeeRiskAssessment:
    'Chi giám định, đánh giá rủi ro đối đượng được bảo hiểm, chi khác ',
  otherInsuranceSellingExpenses: 'Chi bán hàng ',
  others: 'Chi khác ',
  otherReinsuranceAssumedExpenses: 'Chi khác nhận tái bảo hiểm khác',
  otherReinsuranceCededExpenses: 'Chi nhượng tái bảo hiểm ',
  otherDirectInsuranceOperatingExpenses:
    'Chi phí trực tiếp kinh doanh hoạt động khác ',
  totalDirectInsuranceOperatingExpenses:
    'Tổng chi trực tiếp hoạt động kinh doanh bảo hiểm',
  grossInsuranceOperatingProfit: 'Lợi nhuận gộp hoạt động kinh doanh bảo hiểm ',
  netOperatingIncomeFromBankingActivities:
    'Thu nhập thuần từ hoạt động ngân hàng ',
  incomeFromBankingActivities: 'Thu nhập từ hoạt động ngân hàng ',
  expensesFromBankingActivities: 'Chi phí của hoạt động ngân hàng ',
  profitFromRealEstateInvestmentActivities:
    'Lợi nhuận từ hoạt động đầu tư bất động sản ',
  revenueFromRealEstate: 'Doanh thu kinh doanh bất động sản đầu tư',
  costOfRealEstate: 'Giá vốn bất động sản đầu tư',
  profitFromFinancialActivities: 'Lợi nhuận hoạt động tài chính ',
  gainLossFromJointVentures: 'Lãi/lỗ từ công ty liên doanh, liên kết (từ 2015)',
  netOperatingIncomeFromOtherActivities: 'Thu nhập thuần từ hoạt động khác ',
  revenueFromOtherActivities: 'Thu nhập từ hoạt động khác ',
  expensesFromOtherActivities: 'Chi phí hoạt động khác',
  generalAndAdministrativeExpensesOfInsuranceOperation:
    'Chi phí quản lý doanh nghiệp liên quan trực tiếp đến hoạt động bảo hiểm ',
  generalAndAdministrativeExpensesOfBankingOperation:
    'Chi phí quản lý liên quan trực tiếp tới hoạt động ngân hàng',
  generalAndAdministrativeExpensesOfOthersOperation:
    'Chi phí quản lý doanh nghiệp liên quan đến các lĩnh vực khác ',
  netOperatingProfitFromInsuranceOperation:
    'Lợi nhuận thuần hoạt động kinh doanh bảo hiểm ',
  lossFromLifeInsurance: 'Lỗ thuần từ hoạt động bảo hiểm nhân thọ',
  netProfitFromNonLifeInsurance: 'Lãi thuần từ hoạt động bảo hiểm phi nhân thọ',
  netProfitFromBankOperation: 'Lợi nhuận thuần hoạt động ngân hàng ',
  netProfitFromOthersOperation: 'Lợi nhuận thuần từ các hoạt động khác ',
  netOtherIncomeOtherIncome: 'Thu nhập hoạt động khác ',
  netOtherIncomeOtherExpenses: 'Chi phí hoạt động ',
  equalisationReserve: 'Dự phòng đảm bảo cân đối',
  businessIncomeTaxExpenses: 'Chi phí thuế thu nhập doanh nghiệp',
  businessIncomeTaxCurrent: 'Thuế thu nhập doanh nghiệp - hiện thời ',
  businessIncomeTaxDeferred: 'Thuế thu nhập doanh nghiệp - hoãn lại',
  EPS_basis: 'Lãi cơ bản trên cổ phiếu (VND)',

  BalanceSheetInsurance: {
    otherLiabilites: 'Nợ phải trả khác',
    longTermTradeReceivablesChild: 'Phải thu khách hàng dài hạn',
    otherLongtermReceivablesChild: 'Phải thu dài hạn khác',
    capitalAndReservesPreferedShares: 'Cổ phiếu ưu đãi',
    inventoriesNet: 'Hàng tồn kho (Ròng)',
    loansAndAdvancesToCustomersOne: 'CHO VAY VÀ ỨNG TRƯỚC CHO VAY',
    capitalAndReservesPreferredShares: 'Cổ phiếu ưu đãi',
    otherCurrentAssetsChild: 'Tài sản ngắn hạn khác',
    tangibleFixedAssetsCost: 'Nguyên giá',
    tangibleFixedAssetsAccumulatedDepreciation: 'Giá trị hao mòn lũy kế',
    financeLeaseAssetsCost: 'Nguyên giá',
    financeLeaseAssetsAccumulatedDepreciation: 'Giá trị hao mòn lũy kế',
    intagibleFixedAssetsCost: 'Nguyên giá',
    intagibleFixedAssetsAccumulatedDepreciation: 'Giá trị hao mòn lũy kế',
    investmentPropertiesCost: 'Nguyên giá',
    investmentPropertiesAccumulatedDepreciation: 'Giá trị hao mòn lũy kế',

    totalAssets: 'TỔNG CỘNG TÀI SẢN',
    currentAssets: 'TÀI SẢN NGẮN HẠN',
    currentAssetsLower: 'TÀI SẢN NGẮN HẠN',
    cashAndCashEquivalents: 'Tiền và tương đương tiền ',
    cash: 'Tiền  ',
    cashEquivalents: 'Các khoản tương đương tiền',
    shorttermInvestments: 'Đầu tư tài chính ngắn hạn',
    shorttermInvestmentsChild: 'Đầu tư ngắn hạn ',
    provisionForDiminution: 'Dự phòng giảm giá chứng khoán kinh doanh',
    heldtomaturityInvestment: 'Đầu tư nắm giữ đến ngày đáo hạn',
    shorttermInvestmentsHeldtomaturityInvestment:
      'Đầu tư nắm giữ đến ngày đáo hạn',
    accountsReceivables: 'Các khoản phải thu ',
    tradeAccountsReceivables: 'Phải thu của khách hàng',
    receivableFromInsuranceContract: 'Phải thu về hợp đồng Bảo hiểm ',
    otherReceivablesFromCustomers: 'Phải thu khác của khách hàng ',
    prepaymentsToSuppliers: 'Trả trước cho người bán',
    intercompanyReceivables: 'Phải thu nội bộ',
    constructionContractInProgressReceivables: 'Phải thu về XDCB',
    shorttermLoansReceivables: 'Phải thu về cho vay ngắn hạn',
    advancedPayment: 'Tạm ứng',
    receivableFromTradingStocks: 'Phải thu từ hoạt động đầu tư tài chính',
    otherReceivables: 'Các khoản phải thu khác',
    provisionForDoubfulDebts: 'Dự phòng các khoản phải thu khó đòi',
    invetoriesNet: 'Hàng tồn kho ',
    inventories: 'Hàng tồn kho ',
    provisionForDeclineInInventories: 'Dự phòng giảm giá hàng tồn kho',
    otherCurrentAssets: 'Tài sản ngắn hạn khác ',
    shorttermPrepayments: 'Chi phí trả trước ngắn hạn',
    undistributedCommisionExpenses: 'Chi phí hoa hồng chưa phân bổ',
    otherShorttermPrepayments: 'Chi phí trả trước ngắn hạn khác',
    shortageOfCurrentAssetsWaitingForSolution: 'Tài sản thiếu chờ xử lý',
    vatToBeClaimed: 'Thuế GTGT được khấu trừ',
    otherTaxesReceivable: 'Thuế và các khoản phải thu của nhà nước',
    marginDeposits: 'Các khoản cầm cố, ký cược và ký quỹ',
    governmentBondsPurchasedForResale:
      'Giao dịch mua bán lại trái phiếu Chính phủ',
    reinsuranceAssets: 'Tài sản tái bảo hiểm ',
    provisionForPremiumOutwardReinsurance: 'Dự phòng phí nhượng tái bảo hiểm ',
    provisionForClaimFormOutwardReinsurance:
      'Dự phòng bồi thường nhượng tái bảo hiểm ',
    loansAndAdvancesToCustomers: 'Cho vay và ứng trước cho khách hàng',
    provisionForCreditLoss: 'Dự phòng rủi ro tín dụng',
    longtermAsstes: 'TÀI SẢN DÀI HẠN',
    longtermTradeReceivables: 'Phải thu dài hạn',
    longTermTradeReceivables: 'Phải thu dài hạn',
    longtermPrepaymentsToSuppliers: 'Trả trước người bán dài hạn ',
    paidinCapitalInWhollyownedSubsidiaries:
      'Vốn kinh doanh ở các đơn vị trực thuộc',
    longtermIntercompanyReceivables: 'Phải thu nội bộ dài hạn',
    longtermLoansReceivables: 'Phải thu về cho vay dài hạn',
    otherLongtermReceivables: 'Phải thu dài hạn khác',
    insuranceDeposits: 'Ký quỹ bảo hiểm ',
    provisionForDoubfulLongtermReceivables: 'Dự phòng phải thu dài hạn',
    fixedAssets: 'Tài sản cố định',
    tangibleFixedAssets: 'Tài sản cố định hữu hình',
    cost: 'Nguyên giá',
    accumulatedDepreciation: 'Giá trị hao mòn lũy kế',
    financeLeaseAssets: 'Tài sản cố định thuê tài chính',
    intagibleFixedAssets: 'Tài sản cố định vô hình',
    constructionInProgressBefore: 'Chi phí xây dựng cơ bản dở dang ',
    investmentProperties: 'Bất động sản đầu tư',
    longtermIncompleteAssets: 'Tài sản dở dang dài hạn',
    longtermCostOfWorkInProgress: 'Chi phí sản xuất, kinh doanh dở dang ',
    constructionInProgress: 'Chi phí xây dựng cơ bản dở dang ',
    longtermInvestments: 'Các khoản đầu tư tài chính dài hạn',
    investmentInSubsidiaries: 'Đầu tư vào công ty con ',
    investementInAssociates: 'Đầu tư vào công ty liên kết, liên doanh ',
    otherLongtermInvestements: 'Đầu tư dài hạn khác',
    provisionForLongtermInvestments: 'Dự phòng giảm giá đầu tư tài chính ',
    goodWillBefore: 'Lợi thế thương mại (trước 2015)',
    otherLongtermAssets: 'Tài sản dài hạn khác',
    otherLongtermAssetsChild: 'Tài sản dài hạn khác',
    longtermPrepayments: 'Chi phí trả trước dài hạn',
    deferredIncomeTaxAssests: 'Tài sản thuế thu nhập hoãn lại',
    longtermDeposit: 'Tài sản ký quỹ dài hạn',
    longtermEquimentMaterialAndSpare: 'Thiết bị, vật tư, phụ tùng thay thế',
    goodWill: 'Lợi thế thương mại ',
    liabilities: 'NỢ PHẢI TRẢ',
    currentLiabilities: 'Nợ ngắn hạn',
    shorttermLoans: 'Vay và nợ ngắn hạn',
    tradeAccountsPayable: 'Phải trả thương mại',
    payablesFromInsuranceContract: 'Phải trả về hợp đồng bảo hiểm ',
    payablesToSuppliers: 'Phải trả khác cho người bán',
    advancesFromCustomers: 'Người mua trả tiền trước',
    taxesAndOtherPayableToStateBudget: 'Thuế và các khoản phải nộp nhà nước ',
    payableToEmployees: 'Phải trả người lao động',
    accruedExpenses: 'Chi phí phải trả',
    intercompanyPayables: 'Phải trả nội bộ',
    constructionContractInProgressPayables: 'Phải trả về xây dựng cơ bản ',
    shorttermUnrealizedRevenue: 'Doanh thu chưa thực hiện ngắn hạn',
    unearnedCommissionIncome: 'Doanh thu hoa hồng chưa được hưởng',
    otherPayables: 'Các khoản phải trả, phải nộp khác',
    provisionForShorttermLiabilities: 'Dự phòng các khoản phải trả ngắn hạn',
    bonusAndWelfareFunds: 'Quỹ khen thưởng phúc lợi',
    priceStablizationFund: 'Quỹ bình ổn giá',
    governmentBondsPurchasedForResales: 'Giao dịch mua bán lại trái phiếu ',
    insuranceReserve: 'Dự phòng nghiệp vụ bảo hiểm ',
    unearnedPremiumReserve: 'Dự phòng phí bảo hiểm gốc và nhận tái bảo hiểm  ',
    mathematicalReserve: 'Dự phòng toán học',
    claimReserve: 'Dự phòng bồi thường bảo hiểm gốc nhận tái bảo hiểm ',
    catastropheReserve: 'Dự phòng dao động lớn',
    dividendReserve: 'Dự phòng chia lãi',
    equalizationReserve: 'Dự phòng đảm bảo cân đối',
    amountDueToCustomers:
      'Tiền gửi của khách hàng và các tổ chức tín dụng khác',
    depositFormCommercialBanks: 'Tiền gửi của tổ chức tín dụng',
    depositFromCustomers: 'Tiền gửi của khách hàng  ',
    longtermLiabilites: 'Nợ dài hạn',
    longtermTradePayables: 'Phải trả nhà cung cấp dài hạn',
    longtermAdvancesFromCustomers: 'Người mua trả tiền trước dài hạn',
    longtermAccruedExpenses: 'Chi phí phải trả dài hạn',
    intracompanyPayablesForOperatingCapital:
      'Phải trả nội bộ về vốn kinh doanh ',
    longtermIntercompanyPayables: 'Phải tả nội bộ dài hạn ',
    otherLongtermPayables: 'Phải trả dài hạn khác',
    longtermLoans: 'Vay và nợ dài hạn ',
    convertibleBonds: 'Trái phiếu chuyển đổi',
    preferredShares: 'Cổ phiếu ưu đãi',
    paidinCapitalPreferredShares: 'Cổ phiếu ưu đãi',
    longtermDepositMortage: 'Ký quỹ, ký cược dài hạn',
    deferredIncomeTaxesLiabilities: 'Thuế thu nhập hoãn lại phải trả',
    provisionForSeveranceAllowances: 'Dự phòng trợ cấp mất việc làm ',
    provisionForLongtermLiabilites: 'Dự phòng các khoản công nợ dài hạn',
    deferredRevenue: 'Doanh thu chưa thực hiện',
    technologyscienceDevelopmentFund: 'Quỹ phát triển khoa học và công nghệ',
    reservesBefore: 'Dự phòng nghiệp vụ bảo hiểm (trước 2014)',
    unearnedPremiumReserveBefore: 'Dự phòng phí chưa được hưởng (trước 2014)',
    technicalReserveBefore: 'Dự phòng toán học (trước 2014)',
    claimReserveBefore: 'Dự phòng bồi thường (trước 2014)',
    catastropheReserveBefore: 'Dự phòng dao động lớn (trước 2014)',
    dividendReseveBefore: 'Dự phòng chia lãi (trước 2014)',
    equalizatinReserveBefore: 'Dự phòng bảo đảm cân đối (trước 2014)',
    ownersEquity: 'VỐN CHỦ SỞ HỮU',
    capitalAndReserves: 'Vốn chủ sở hữu',
    paidinCapital: 'Vốn đầu tư của chủ sở hữu',
    commonShares: 'Cổ phiếu phổ thông',
    capitalSurplus: 'Thặng dư vốn cổ phần',
    ownersOtherCapital: 'Vốn khác',
    treasuryShares: 'Cổ phiếu quỹ',
    differencesUponAssetsRevaluation: 'Chêch lệch đánh giá lại tài sản ',
    foreignExchangeDifferences: 'Chêch lệch tỷ giá',
    investmentAndDevelopmentFunds: 'Quỹ đầu tư và phát triển ',
    financialReserveFunds: 'Quỹ dự phòng tài chính',
    statutoryReserve: 'Quỹ dự trữ bắt buộc ',
    otherFunds: 'Quỹ khác',
    undistributedEarnings: 'Lợi nhuận sau thuế chưa phân phối',
    beginningAccumulatedUndistritbutedEarning:
      'LNST chưa phân phối lũy kế đến cuối kỳ trước',
    currentPeriodUndistributedEarnings: 'LNST chưa phân phối kỳ này',
    enterpriseArragementFund: 'Quỹ hỗ trợ sắp xếp doanh nghiệp ',
    minorityInterest: 'Lợi ích cổ đông thiểu số  ',
    budgetSourcesAndOtherFunds: 'Vốn ngân sách nhà nước',
    budgetSourcesAndOtherFundsChild: 'Vốn ngân sách nhà nước',
    bonusAndWelfareFundsBefore: 'Quỹ khen thưởng phúc lợi (trước 2010)',
    fundsUsedForFixedAssetAcquisitions: 'Nguồn kinh phí đã hình thành TSCĐ',
    minorityInterestBefore: 'LỢI ÍCH CỔ ĐÔNG THIỂU SỐ (trước 2015)',
    totalResources: 'TỔNG CỘNG NGUỒN VỐN',
    shareholdersEquity: 'VỐN CHỦ SỞ HỮU',
    otherAssets: 'Tài sản khác',
  },

  BalanceSheetCK: {
    otherAssets: 'Tài sản khác',
    shareholdersEquity: 'VỐN CHỦ SỞ HỮU',
    longTermLiabilities: 'Nợ dài hạn',
    totalAssets: 'TỔNG CỘNG TÀI SẢN',
    currentAssets: 'TÀI SẢN NGẮN HẠN',
    shorttermFinancialAssets: 'Tài sản tài chính ngắn hạn',
    cashAndCashEquivalents: 'Tiền và tương đương tiền ',
    cash: 'Tiền',
    cashEquivalents: 'Các khoản tương đương tiền',
    shorttermInvestments: 'Giá trị thuần đầu tư tài sản tài chính ngắn hạn ',
    shorttermInvestmets:
      'Các tài sản tài chính ghi nhận thông qua lãi/lỗ (FVTPL)',
    heldtomaturityInvestment: 'Các khoản đầu tư nắm giữ đến ngày đáo hạn (HTM)',
    loans: 'Các khoản cho vay',
    availableForSalesAssets: 'Các khoản tài chính sẵn sàng để bán (AFS)',
    provisionForDiminution: 'Dự phòng giảm giá chứng khoán kinh doanh ',
    accountsReceivables: 'Tổng các khoản phải thu',
    receivablesFrom: 'Các khoản phải thu (từ 2016)',
    tradeAccountsReceivable: 'Phải thu khách hàng ',
    deductibleValueAddedTax: 'Thuế giá trị gia tăng được khấu trừ',
    receivablesFromServicesProvidedByTheSecurities:
      'Phải thu các dịch vụ CTCK cung cấp ',
    prepaymentsToSuppliers: 'Trả trước người bán',
    intercompanyReceivables: 'Phải thu nội bộ',
    receivablesAriseFromTransactionErrors: 'Phải thu về lỗi giao dịch CK',
    receivableFromTradingStocks: 'Phải thu về hoạt động giao dịch chứng khoán',
    constructionContractInProgress: 'Phải thu về XDCB',
    shorttermLoansReceivables: 'Phải thu về cho vay ngắn hạn',
    otherReceivables: 'Phải thu khác ',
    provisionForShorttermReceivables:
      'Dự phòng suy giảm giá trị các khoản phải thu',
    ProvisionForDoubtfulDebts: 'Dự phòng nợ khó đòi',
    ShortageOfCurrentAssetsWatitingForSolution: 'Tài sản thiếu chờ xử lý',
    inventoriesNet: 'Hàng tồn kho (Ròng)',
    inventories: 'Hàng tồn kho  ',
    provisionForDeclineInInventories: 'Dự phòng giảm giá HTK',
    otherCurrentAssets: 'Tài sản lưu động khác',
    advancePayment: 'Tạm ứng ',
    toolsAndEquipments: 'Vật tư văn phòng, công cụ, dụng cụ',
    shorttermPrepayments: 'Chi phí trả trước ngắn hạn',
    shorttermCollaterals: 'Cầm cố, thế chấp, ký quỹ và ký cược ngắn hạn',
    vatToBeClaimed: 'Thuế VAT được khấu trừ',
    otherTaxesReceivables: 'Phải thu thuế khác',
    governmentBondsPurchasedForResales:
      'Giao dịch mua bán lại trái phiếu chính phủ',
    otherCurrentAssets_38: 'Tài sản lưu động khác',
    provisionForOtherCurrentAssets: 'Dự phòng suy giảm giá trị TSNH khác',
    longtermAssets: 'TÀI SẢN DÀI HẠN ',
    longtermFinancialAssets: 'Tài sản tài chính dài hạn',
    longtermTradeReceivables: 'Phải thu dài hạn',
    longtermTradeReceivables_43: 'Phải thu khách hàng dài hạn',
    longtermPrepaymentsToSuppliers: 'Trả trước người bán dài hạn ',
    paidinCapitalInWhollyownedSubsidiaries:
      'Vốn kinh doanh ở các đơn vị trực thuộc',
    longtermIntercompanyReceivables: 'Phải thu nội bộ dài hạn',
    longtermLoansReceivables: 'Phải thu về cho vay dài hạn',
    otherLongtermReceivables: 'Phải thu dài hạn khác',
    provisionForDoubtfulLongtermReceivables: 'Dự phòng phải thu dài hạn',
    longtermInvestments: 'Đầu tư dài hạn',
    investmentsInSubsidiaries: 'Đầu tư vào các công ty con',
    investmentsInAssociates: 'Đầu tư vào công ty liên kết ',
    longtermSecuritiesInvestment: 'Đầu tư chứng khoán dài hạn',
    otherLongtermInvestment: 'Đầu tư dài hạn khác',
    provisionForLongtermInvestments:
      'Dự phòng giảm giá tài sản tài chính dài hạn',
    fixedAssets: 'Tài sản cố định',
    tangibleFixedAssets: 'GTCL TSCĐ hữu hình',
    cost: 'Nguyên giá TSCĐ hữu hình',
    accumulatedDepreciation: 'Khấu hao lũy kế TSCĐ hữu hình',
    RevaluationOfTangibleFixedAssetsUsingFairValueModel:
      'Đánh giá TSCĐHH theo giá trị hợp lý',
    financeLeaseAssets: 'GTCL tài sản thuê tài chính',
    cost_62: 'Nguyên giá tài sản thuê tài chính',
    accumulatedDepreciation_63: 'Khấu hao lũy kế tài sản thuê tài chính',
    RevaluationOfTangibleFixedAssetsUsingFairValueModel_64:
      'Đánh giá TSCĐTTC theo giá trị hợp lý',
    intangibleFixedAssets: 'GTCL tài sản cố định vô hình',
    cost_66: 'Nguyên giá TSCĐ vô hình',
    accumulatedDepreciation_67: 'Khấu hao lũy kế TSCĐ vô hình',
    RevaluationOfTangibleFixedAssetsUsingFairValueModel_68:
      'Đánh giá TSCĐVH theo giá trị hợp lý',
    constructionInProgressBefore: 'Xây dựng cơ bản dở dang (trước 2015) ',
    investmentProperties: 'Giá trị ròng bất động sản đầu tư',
    cost_71: 'Nguyên giá bất động sản đầu tư',
    accumulatedDepreciation_72: 'Khấu hao lũy kế bất động sản đầu tư',
    revaluationOfInvestmentPropertyUsingFairValueModel:
      'Đánh giá BĐSĐT theo giá trị hợp lý',
    longtermIncompleteAssets: 'Tài sản dở dang dài hạn',
    longtermCostOfWorkInProgress:
      'Chi phí sản xuất, kinh doanh dở dang dài hạn',
    constructinInProgress: 'Xây dựng cơ bản dở dang   ',
    otherLongtermAssets: 'Tài sản dài hạn khác',
    longtermCollaterals: 'Cầm cố, thế chấp, ký quỹ và ký cược dài hạn',
    longtermPrepayments: 'Trả trước dài hạn',
    deferredIncomeTaxAssets: 'Thuế thu nhập hoãn lại phải thu',
    longtermEquipmentMaterialAndSpareParts:
      'Thiết bị, vật tư, phụ tùng thay thế dài hạn',
    paymentsToSettlementAssistanceFund: 'Tiền chi nộp quỹ hỗ trợ thanh toán ',
    otherLongtermAssets_83: 'Các tài sản dài hạn khác',
    goodwill: 'Lợi thế thương mại',
    provisionForLongTermAssets: 'Dự phòng suy giảm giá trị tài sản dài hạn',
    liabilities: 'NỢ PHẢI TRẢ',
    currentLiabilities: 'Nợ ngắn hạn',
    shorttermLoans: 'Vay và nợ thuê tài chính ngắn hạn',
    shorttermLoans_89: 'Vay nợ ngắn hạn',
    shorttermFinanceLease: 'Nợ thuê tài chính ngắn hạn',
    shorttermFinancialAssets_91: 'Vay tài sản tài chính ngắn hạn',
    shorttermConvertibleBonds: 'Trái phiếu chuyển đổi ngắn hạn',
    shorttermBondsIssued: 'Trái phiếu phát hành ngắn hạn',
    loansFromPayableAssistanceFund: 'Vay quỹ hỗ trợ thanh toán',
    payablesToSecuritiesTrading: 'Phải trả hoạt động giao dịch chứng khoán',
    payableAriseFromTransactionErrors:
      'Phải trả về lỗi giao dịch các tài sản tài chính',
    tradeAccountsPayable: 'Phải trả người bán ngắn hạn',
    advancesFromCustomers: 'Người mua trả tiền trước ngắn hạn',
    taxesAndOtherPayableToStateBudget: 'Các khoản phải trả về thuế',
    payableToEmployees: 'Phải trả người lao động',
    employeesWelfarePayableToAuthorities:
      'Các khoản trích nộp phúc lợi nhân viên',
    accruedExpenses: 'Chi phí phải trả',
    intercompanyPayables: 'Phải trả nội bộ',
    shorttermUnrealizedRevenue: 'Doanh thu chưa thực hiện ngắn hạn',
    shorttermCollateralsReceivables: 'Nhận ký quỹ, ký cược ngắn hạn',
    constructionContractInProgress_106: 'Phải trả về xây dựng cơ bản ',
    dividendPrincipalAndInterestsPayables:
      'Phải trả cổ tức, gốc và lãi trái phiếu',
    payablesToSecuritiesIssues: 'Phải trả tổ chức phát hành chứng khoán',
    otherPayables: 'Phải trả khác',
    provisionForShorttermLiabilities: 'Dự phòng các khoản phải trả ngắn hạn ',
    bonusAndWelfareFunds: 'Quỹ khen thưởng phúc lợi ',
    priceStabilizationFund: 'Quỹ bình ổn giá',
    governmentBondsPurchasedForResale:
      'Giao dịch mua bán lại trái phiếu chính phủ',
    longtermLiabilities: 'Nợ dài hạn',
    LongtermLoans: 'Vay và nợ thuê tài sàn tài chính dài hạn',
    LongtermLoans_116: 'Vay dài hạn',
    LongtermFinanceLease: 'Nợ thuê tài chính dài hạn',
    longtermFinancialAssetsLoans: 'Vay tài sản tài chính dài hạn',
    convertibleBonds: 'Trái phiếu chuyển đổi dài hạn',
    longtermBonds: 'Trái phiếu phát hành dài hạn',
    longtermTradePayables: 'Phải trả nhà cung cấp dài hạn',
    longtermAdvancesFromCustomers: 'Người mua trả tiền trước dài hạn',
    longtermAccruedExpenses: 'Chi phí phải trả dài hạn',
    longtermIntercompanyPayables: 'Phải trả nội bộ dài hạn',
    intracompanyPayablesForOperatingCapitalReceived:
      'Phải trả nội bộ về vốn kinh doanh',
    deferredRevenue: 'Doanh thu chưa thực hiện ',
    longtermCollateralsReceived: 'Nhận ký quỹ, ký cược dài hạn',
    otherLongtermPayables: 'Phải trả dài hạn khác',
    preferredShares: 'Cổ phiếu ưu đãi',
    provisionForSeveranceAllowances: 'Dự phòng trợ cấp thôi việc',
    provisionForLongtermLiabilities: 'Dự phòng các khoản công nợ dài hạn',
    provisionForCompensationOfInvestors: 'Quỹ bảo vệ nhà đầu tư',
    DeferredIncomeTaxLiabilities: 'Thuế thu nhập hoãn lại phải trả',
    technologyscienceDevelopmentFund: 'Quỹ phát triển khoa học công nghệ',
    ownersEquity: 'VỐN CHỦ SỞ HỮU',
    capitalAndReserves: 'Vốn và các quỹ',
    sharholdersEquity: 'Vốn đầu tư của chủ sở hữu',
    paidinCapital: 'Vốn góp',
    capitalSurplus: 'Thặng dư vốn cổ phần ',
    conversionOptionsOnConvertibleBonds: 'Quyền chọn chuyển đổi trái phiếu',
    ownersOtherCapital: 'Vốn khác',
    treasuryShares: 'Cổ phiếu quỹ',
    differencesUponAssetRevaluation: 'Chêch lệch đánh giá lại tài sản ',
    foreignExchangeDifferences: 'Chêch lệch tỷ giá',
    charterReserve: 'Quỹ dự trữ điều lệ',
    investmentAndDevelopment: 'Quỹ đầu tư và phát triển ',
    financialReserveFunds: 'Quỹ dự phòng tài chính ',
    otherFunds: 'Quỹ khác',
    undistributedEarnings: 'Lợi nhuận chưa phân phối',
    realizedGain: 'Lợi nhuận đã thực hiện ',
    unrealizedGain: 'Lợi nhuận chưa thực hiện',
    minorityInterest: 'Lợi ích cổ đông thiểu số',
    budgetSourcesAndOtherFunds: 'Vốn Ngân sách nhà nước và quỹ khác',
    bonusAndWelfareFundsBefore: 'Quỹ khen thưởng , phúc lợi (trước 2010)',
    budgetSourcesAndOtherFunds_155: 'Vốn ngân sách nhà nước  ',
    fundsUsedForFixedAssetAcquisitions: 'Nguồn kinh phí đã hình thành TSCĐ',
    minorityInterestBefore: 'LỢI ÍCH CỦA CỔ ĐÔNG THIỂU SỐ (trước 2015)',
    totalResources: 'TỔNG CỘNG NGUỒN VỐN',
    distributedProfitToInvestor: 'LỢI NHUẬN ĐÃ PHÂN PHỐI CHO NHÀ ĐẦU TƯ',
    distributedProfitToInvestorDuringTheYear:
      'Lợi nhuận đã phân phối cho nhà đầu trong năm ',
  },

  //income statement ck
  incomeStatementCK: {
    sales: 'Doanh thu hoạt động',
    incomeFromFinancialAssetsRegconizedThroughProfitlossFvtpl:
      'Lãi từ các tài sản tài chính ghi nhận thông qua lãi/lỗ ( FVTPL)',
    incomeFromSellingFinancialAssets: 'Lãi bán các tài sản tài chính',
    fvtplRevaluationGain:
      'Chêch lệch tăng đánh giá lại các tài sản tài chính thông qua lãi/lỗ',
    dividendInterestFromFvtplFinancialAssets:
      'Cổ tức, tiền lãi phát sinh từ tài sản tài chính FVTPL',
    incomeFromHeldToMaturityInvestmentHtm:
      'Lãi từ các khoản đầu tư nắm giữ đến ngày đáo hạn (HTM)',
    incomeFromLoansAndReceivables: 'Lãi từ các khoản cho vay và phải thu',
    incomeFromAvailableForSalesAssetsAfs:
      'Lãi từ các tài sản tài chính sẵn sàng để bán (AFS)',
    incomeFromDerivatives: 'Lãi từ các công cụ phát sinh phòng ngừa rủi ro',
    revenueInBrokerageServices: 'Doanh thu hoạt động môi giới chứng khoán',
    revenueInUnderwritingServices: 'Doanh thu bảo lãnh phát hành chứng khoán',
    revenueInIssuanceAgencyServices: 'Doanh thu đại lý phát hành chứng khoán',
    revenueInAdvisoryServices: 'Doanh thu hoạt động tư vấn đầu tư chứng khoán',
    revenueInAuctionTrustServices: 'Doanh thu hoạt động ủy thác, đấu giá',
    revenueInSecuritiesCustodyService: 'Doanh thu lưu ký chứng khoán',
    revenueInSecuritiesInvestmentAndOtherInvestmentActivitives:
      'Doanh thu hoạt động đầu tư chứng khoán, góp vốn',
    retalIncomeFromInvestmentProperty: 'Thu cho thuê sử dụng tài sản ',
    revenueIncomeFromAdvisoryServices: 'Doanh thu hoạt động tư vấn tài chính',
    OtherRevenues: 'Doanh thu khác',
    salesDeductions: 'Các khoản giảm trừ doanh thu',
    netSales: 'Doanh thu thuần về hoạt động kinh doanh',
    costOfSales: 'Chi phí hoạt động kinh doanh',
    lossFromFinancialAssetsRecognizedThroughProfitlossFvtpl:
      'Lỗ các tài sản tài chính ghi nhận thông qua lãi lỗ (FVTPL)',
    lossFromSellingFinancialAssetsFvtpl: 'Lỗ bán các tài sản tài chính',
    fvtplFinancialAssetsRevaluationLoss:
      'Chêch lệch giảm đánh giá lại các tài sản tài chính FVTPL',
    fvtplFinancialAssetsPurchaseTransactionCosts:
      'Chi phí giao dịch mua các tài sản tài chính FVTPL',
    lossFromHeldToMaturityInvestment:
      'Lỗ các khoản đầu tư nắm giữ đến ngày đáo hạn (HTM)',
    interestCostLossFromLoansAndReceivables:
      'Chi phí lãi vay, lỗ từ các khoản cho vay và phải thu',
    lossFromAvailableForSalesAssetsAfs:
      'Lỗ và ghi nhận chêch lệch đánh giá theo giá trị hợp lý tài sản tài chính sẵn sàng để bán (AFS)',
    provisionForLossesFromMortgageAssetsUncollectibleReceivablesAndBorrowingExpenses:
      'CP dự phòng TSTC, xử lý tổn thất các khoản phải thu khó đòi và lỗ suy giảm TSTC và CP đi vay',
    lossFromDerivatives:
      'Lỗ từ các tài sản tài chính phái sinh phòng ngừa rủi ro ',
    proprietaryTradingServicesExpenses: 'Chi phí hoạt động tự doanh ',
    brokerageExpenses: 'Chi phí môi giới chứng khoán',
    underwritingSecuritiesIssuanceExpenses:
      'Chi phí hoạt động bảo lãnh, đại lý phát hành chứng khoán',
    expensesForSecuritiesAdvisory: 'Chi phí tư vấn đầu tư chứng khoán',
    biddingAgentServiceExpensee: 'Chi phí hoạt động đấu giá, ủy thác',
    investorsSecuritiesDepositoryExpenses: 'Chi phí lưu ký chứng khoán',
    expensesForFinancialAdvisoryActivities:
      'Chi phí hoạt đông tư vấn tài chính',
    otherExpenses: 'Chi phí các dịch vụ khác',
    grossProfit: 'Lợi nhuận gộp',
    revenueFromFinancialActivities: 'Doanh thu hoạt động tài chính ',
    realizedAndUnrealizedForeignExchangeGain:
      'Chêch lệch lãi tỷ giá hối đoái đã và chưa thực hiện',
    incomeFromNonFixedAccruedDividendAndInterest:
      'Doanh thu, dự thu cổ tức, lãi tiền gửi không cố định phát sinh trong kỳ',
    gainFromDisposalsOrSalesOfInvestmentInSubsidiariesAssociatesAndJointVentures:
      'Lãi bán, thanh lý các khoản đầu tư vào công ty con, liên kết, liên doanh',
    otherRevenueFromInvestments: 'Doanh thu khác về đầu tư',
    financialExpenses: 'Chi phí tài chính',
    realizedAndUnrealizedForeignExchangeLoss:
      'Chêch lệch lỗ tỷ giá hối đoái đã và chưa thực hiện',
    interestExpenses: 'Chi phí lãi vay  ',
    lossFromDisposalsOrSalesOfInvestmentsInSubsidiariesAssociatesAndJointVentures:
      'Lỗ bán, thanh lý các khoản đầu tư vào công ty con, liên kết, liên doanh',
    provisionForLossesOnLongtermFinancialInvestement:
      'Chi phí dự phòng suy giảm giá trị các khoản đầu tư tài chính dài hạn',
    otherInvestmentExpenses: 'Chi phí tài chính khác',
    gainlossFromJoinVentures: 'Lãi/lỗ từ công ty liên doanh, liên kết ',
    sellingCosts: 'Chi phí bán hàng ',
    generalAndAdminExpenses: 'Chi phí quản lý công ty chứng khoán',
    operatingProfitloss: 'Kết quả hoạt động',
    netOtherIncomeexpenses: 'Thu nhập khác ròng',
    otherIncome: 'Thu nhập khác',
    otherExpenses_57: 'Chi phí khác',
    incomeFromInvestmentInOtherEntitiesBefore:
      'Lãi/lỗ từ công ty liên doanh (trước 2015)',
    netAccountingProfitlossBeforeTax: 'Tổng lợi nhuận kế toán trước thuế',
    realizedGain: 'Lợi nhuận đã thực hiện',
    unrealizedGain: 'Lợi nhuận chưa thực hiện',
    businessIncomeTaxExpenses: 'Chi phí thuế thu nhập doanh nghiệp',
    businessIncomeTaxCurrent: 'Chi phí thuế thu nhập hiện hành',
    businessIncomeTaxdeferred: 'Chi phí thuế thu nhập hoãn lại',
    netProfitlossAfterTax: 'Lợi nhuận kế toán sau thuế',
    attributableToParentCompany: 'Lợi nhuận sau thuế phân bổ cho chủ sở hữu',
    profitAfterTaxDeductedOfFunds:
      'LNST trích các Quỹ dự trữ điều lệ, Quỹ dự phòng tài chính và RR nghề nghiệp theo quy định điều lệ Công ty',
    minorityInterests: 'Lợi ích cổ đông thiểu số ',
    otherComprehensiveGainLossAfterTax:
      'Thu nhập (lỗ) toàn diện khác sau thuế TNDN',
    gainlossFromRevaluationOfHeldMaturityInvestments:
      'Lãi/lỗ từ đánh giá lại các khoản đầu tư giữ đến ngày đáo hạn',
    gainlossFromRevaluationOfAvailableForSalesFinancialAssets:
      'Lãi/lỗ từ đánh giá lại các tài sản tài chính sẵn sàng để bán',
    gainlossDistributedFromInvestmentsInSubsidiariesAssociatesAndJointVentures:
      'Lãi/lỗ toàn diện khác được chia từ hoạt động đầu tư vào công ty con, đầu tư liên kết, liên doanh',
    gainlossFromRevaluationOfDerivatives:
      'Lãi/lỗ từ đánh giá lại các công cụ tài chính phái sinh',
    gainlossFromForeignExchangeDifferenceOfOverseaOperations:
      'Lãi/lỗ chêch lệch tỷ giá của hoạt động tại nước ngoài',
    predistributedGainlossFromInvestmentsInSubsidiariesAssociatesAndJointVentures:
      'Lãi/lỗ từ các khoản đầu tư vào công ty con, công ty liên kết, liên doanh chưa chia',
    gainlossFromRevaluationOfDerivatives_76:
      'Lãi/lỗ đánh giá công cụ phái sinh',
    gainlossFromRevaluationOfFixedAssetsUsingFairValueModel:
      'Lãi/lỗ đánh giá lại tài sản cố định theo mô hình giá trị hợp lý',
    comprehensiveIncomeDistributedToShareholders:
      'Thu nhập toàn diện phân bổ cho chủ sở hữu',
    comprehensiveIncomeDistributedToUncontrolledShareholders:
      'Thu nhập toàn diện phân bổ cho cổ đông không kiểm soát',
    netIncomeToCommonShare: 'Thu nhập thuần trên cổ phiếu phổ thông',
    epsBasic: 'Lãi cơ bản trên cổ phiếu (VND)',
    epsDiluted: 'Thu nhập pha loãng trên cổ phiếu (VND)',
    ebit: 'EBIT',
    ebitDa: 'EBITDA',
  },
  //CF BH
  cashFlowStatementInsurance: {
    netCashInflowsoutflowsFromOperatingActivities:
      'Lưu chuyển tiền thuần từ hoạt động kinh doanh',
    operatingProfitlossBeforeChangesInWc:
      'Lợi nhuận từ hoạt động kinh doanh trước thay đổi vốn lưu động',
    netProfitlossBeforeTax: 'Lợi nhuận trước thuế',
    depreciationAndAmortisation: 'Khấu hao TSCĐ',
    amortisationOfGoodwill: 'Phân bổ lợi thế thương mại',
    provisions: 'Các khoản dự phòng',
    unrealisedForeignExchange: 'Lãi/lỗ chêch lệch tỷ giá hối đoái',
    profitlossFromInvesting: 'Lãi/lỗ từ hoạt động đầu tư',
    interestExpense: 'Chi phí lãi vay',
    interestIncomeAndDividend: 'Thu lãi và cổ tức ',
    otherAdjustments: 'Các khoản điều chỉnh khác',
    increasedecreaseInReceivables: 'Tăng/giảm các khoản phải thu',
    grossWrittenPremiumReceivables: 'Phải thu hoạt động BH gốc',
    reinsuranceAssumedReceivables: 'Phải thu hoạt động nhận tái BH',
    reinsuranceCededReceivables: 'Phải thu hoạt động nhượng tái BH',
    otherReceivablesFromInsuranceActivities: 'Phải thu hoạt động khác',
    intercompanyReceivablespayables: 'Phải thu/trả đơn vị nội bộ',
    increasedecreaseInInventories: 'Tăng/giảm hàng tồn kho',
    increasedecreaseInPayablesNotIncludingInterestPaidAndTaxExpensePaid:
      'Tăng/giảm các khoản phải trả (không kể lãi vay phải trả, thuế thu nhập phải nộp)',
    grossWrittenPremiumPayables: 'Phải trả hoạt động BH gốc',
    reinsuranceAssumedPayables: 'Phải trả hoạt động nhận tái BH',
    reinsuranceCededPayables: 'Phải trả hoạt động nhượng tái BH',
    otherPayablesFromInsuranceActivities: 'Phải trả hoạt động khác',
    payablesToEmployees: 'Phải trả CBCNV',
    increasedecreaseInPrepaidExpenese: 'Tăng/giảm chi phí trả trước',
    increasedecreaseInTradingSecurities: 'Tăng/giảm chứng khoán kinh doanh',
    interestPaid: 'Tiền lãi vay đã trả',
    businessIncomeTaxPaid: 'Thuế thu nhập doanh nghiệp đã nộp',
    otherReceiptsFromOperatingActivities:
      'Tiền thu khác từ hoạt động kinh doanh',
    otherPaymentsOnOperatingActivities: 'Tiền chi khác từ hoạt động kinh doanh',
    netCashInflowsoutflowsFromInvestingActivities:
      'Lưu chuyển tiền thuần từ hoạt động đầu tư',
    purchasesOfFixedAssetsAndOtherLongtermAssets:
      'Tiền chi mua sắm, xây dựng TSCĐ và các tài sản dài hạn khác',
    proceedsFromDisposalOfFixedAssets:
      'Tiền thu từ thanh lý, nhượng bán TSCĐ và các tài sản dài hạn khác',
    loansGrantedPurchasesOfDebtInstrument:
      'Tiền chi cho vay, mua các công cụ nợ của đơn vị khác',
    collectionOfLoansProceedsFromSalesOfDebtsInstruments:
      'Tiền thu hồi cho vay, bán lại các công cụ nợ của đơn vị khác',
    investmentInOtherEntities: 'Tiền chi đầu tư góp vốn vào đơn vị khác',
    proceedsFromDivestmentInOtherEntities:
      'Tiền thu hồi đầu tư góp vốn vào đơn vị khác',
    dividendsAndInteresteReceived:
      'Tiền thu lãi cho vay, cổ tức và lợi nhuận được chia',
    netCashInflowsoutflowsFromFinancingActivities:
      'Lưu chuyển tiền thuần từ hoạt động tài chính',
    proceedsFromIssueOfShares:
      'Tiền thu phát hành cổ phiếu, nhận vốn góp của chủ sở hữu',
    paymentsForShareReturensAndRepurchases:
      'Tiền chi trả vốn góp cho các chủ sở hữu, mua lại cổ phiếu của doanh nghiệp đã phát hành',
    proceedsFromLoans: 'Tiền vay ngắn, dài hạn được nhận',
    repaymentOfLoans: 'Tiền chi trả nợ gốc vay',
    financeLeasePrincipalPayments: 'Tiền chi trả nợ thuê tài chính',
    dividendPaid: 'Cổ tức, lợi nhuận đã trả cho chủ sở hữu',
    netIncreaseInCashAndCashEquivalents: 'Lưu chuyển tiền thuần trong kỳ',
    cashAndCashEquivalentsAtTheBeginningOfThePeriod:
      'Tiền và tương đương tiền đầu kỳ',
    effectOfForeignExchangeDifferences:
      'Ảnh hưởng của thay đổi tỷ giá hối đoái quy đổi ngoại tệ',
    cashAndCashEquivalentsAtTheEndOfThePeriod:
      'Tiền và tương đương tiền cuối kỳ',
  },

  //CF CK
  cashFlowStatementCK: {
    netCashInflowsoutflowsFromOperatingActivies:
      'Lưu chuyển thuần từ hoạt động kinh doanh chứng khoán',
    operatingProfitlossBeforeChangesInWc:
      'Lợi nhuận từ hoạt động kinh doanh trước thay đổi vốn lưu động',
    netProfitlossBeforeTax: 'Lợi nhuận trước thuế',
    adjustment: 'Điều chỉnh cho các khoản',
    depreciationAndAmortisation: 'Khấu hao tài sản cố định',
    amortisationOfGoodwill: 'Phân bổ lợi thế thương mại',
    provisions: 'Các khoản dự phòng',
    unrealisedForeignExchangeGainloss:
      'Lãi, lỗ chêch lệch tỷ giá hối đoái chưa thực hiện',
    accruedExpenses: 'Chi phí phải trả, chi phí trả trước',
    profitlossFromInvestingActivities: 'Lãi, lỗ hoạt động đầu tư',
    interestExpense: 'Chi phí lãi vay',
    interestIncomeAndDividend: 'Dự thu tiền lãi',
    otherAdjustments: 'Các khoản điều chỉnh khác',
    increaseInNoncashExpense: 'Tăng các chi phí tiền tệ',
    lossOnValuationOfFairValueThroughProfitlossFinancialAssets:
      'Lỗ đánh giá giá trị các tài sản tài chính ghi nhận thông qua lãi/lỗ FVTPL',
    lossFromFinancialAssetsSales:
      'Lỗ đánh giá giá trị các công nợ tài chính ghi nhận thông qua KQKD',
    lossFromDerivatives: 'Lỗ đánh giá giá trị các công cụ tài chính phái sinh',
    lossOnValuationOfAvailableForSaleFinancialAssets:
      'Lỗ từ thanh lý các tài sản tài chính sẵn sàng để bán',
    decreaseInTheValueOfAvailableSalesAssets:
      'Suy giảm giá trị của các tài sản tài chính sẵn sàng để bán ',
    lossOnValuationOfHeldToMarturityInvestments:
      'Lỗ suy giảm giá trị các khoản đầu tư nắm giữ đến ngày đáo hạn',
    lossOnTheDecreaseInValueOfLoansGiven:
      'Lỗ suy giảm giá trị các khoản cho vay',
    lossRegconizedWhenReclassificationOfAfsIsMadeAndFairValueIsUsedForRevaluation:
      'Lỗ về ghi nhận chêch lệch đánh giá theo giá trị hợp lý tài sản tài chính sẵn sàng để bán AFS khi phân loại lại',
    lossFromDerivatives_22:
      'Lỗ đánh giá giá các công cụ tài chính phát sinh cho mục đích phòng ngừa rủi ro',
    lossFromSalesOfFixedAssets: 'Lỗ từ thanh lý TSCĐ',
    decreaseInValueOfFixedAssets:
      'Suy giảm giá trị của các tài sản cố định, BĐSĐT',
    provisionForDecreaseInValueOfLongtermFinancialInvestments:
      'Chi phí dự phòng suy giảm giá trị các khoản đầu tư tài chính dài hạn',
    lossFromDisposalsOrSalesOfInvestmentInSubsidiariesAssociatesAndJointVentures:
      'Lỗ từ thanh lý các khoản đầu tư vào công ty con và công ty liên doanh, liên kết',
    otherLoss: 'Lỗ khác',
    decreaseInNoncashRevenue: 'Giảm các doanh thu phi tiền tệ',
    gainFromRevaluationOfFairValueThroughProfitAndLossFinancialAssets:
      'Lãi đánh giá giá trị tài sản tài chính ghi nhận thông qua lãi/lỗ FVTPL',
    gainFromRevaluationOfFairValueThroughProfitAndLossFinancialDebts:
      'Lãi đánh giá giá trị các công nợ tài chính thông qua kết quả kinh doanh',
    gainFromSalesOfAvailableForSaleAssets:
      'Lãi từ thanh lý các tài sản tài chính sẵn sàng để bán khi phân loại lại',
    reversalOfLossFromAvailableForSaleAssets:
      'Hoàn nhập suy giảm giá trị của các tài sản tài chính sẵn sàng để bán',
    gainRecognizedWhenReclassificationOfAfsIsMadeAndFairValueIsUsedForRevaluation:
      'Lãi về ghi nhận chêch lệch đánh giá theo giá trị hợp lý tài sản tài chính sẵn sàng để bán AFS khi phân loại lại',
    gainFromDerivatives:
      'Lãi đánh giá giá trị các công cụ tài chính phái sinh cho mục đích phòng ngừa',
    gainFromTheDecreaseInValueOfLoansGiven:
      'Lãi từ thanh lý các khoản cho vay và phải thu',
    reversalOfProvision: 'Hoàn nhập chi phí dự phòng',
    gainFromSalesOfFixedAssetsAndProperties:
      'Lãi từ thanh lý tài sản cố định, BĐSĐT',
    gainFromDisposalsOrSalesOfInvestmentsInSubsidiariesAssociatesAndJointVentures:
      'Lãi từ thanh lý các khoản đầu tư vào công ty con và công ty liên doanh, liên kết',
    otherGain: 'Lãi khác',
    changeInAssetsAndOperatingLiabilities:
      'Thay đổi tài sản và nợ phải trả hoạt động',
    increaseDecreaseInFairValueThroughProfitAndLossFinancialAssets:
      'Tăng/giảm tài sản tài chính ghi nhận thông qua lãi lỗ',
    increaseDecreaseInHeldToMarturityInvestments:
      'Tăng/giảm các khoản đầu tư giữ đến ngày đáo hạn',
    increaseDecreaseInLoansGiven: 'Tăng/giảm các khoản cho vay ',
    increaseDecreaseInAvailableforsaleFinancialAssets:
      'Tăng/giảm tài sản tài chính sẵn sàng để bán AFS',
    increaseDecreaseInOtherAssets: 'Tăng/giảm các tài sản khác',
    increaseDecreaseInReceivableFromSellingFinancialAssets:
      'Tăng/giảm các khoản phải thu bán các tài sản tài chính',
    increaseDecreaseInFinancialAssetLoansAndFinancialLease:
      'Tăng/giảm vay và nợ thuê tài sản tài chính',
    increaseDecreaseInFinancialAssetLoans: 'Tăng/giảm vay tài sản tài chính',
    increaseDecreaseInCovertibleBondequityPortion:
      'Tăng/giảm Trái phiếu chuyển đổi - Cấu phần nợ',
    increaseDecreaseInIssuedBond: 'Tăng/giảm Trái phiếu phát hành',
    increaseDecreaseInBorrowingFromSettlementAssistanceFund:
      'Tăng/giảm vay Quỹ hỗ trợ Thanh toán',
    IncreaseDecreaseInReceivableFromSellingFvtplFinancialAssets:
      '(-) Tăng, (+) giảm phải thu bán các tài sản tài chính ghi nhận thông qua lãi/lỗ FVTPL',
    IncreaseDecreaseInReceivableFromInterestsOfFinancialAssets:
      '(-) Tăng, (+) giảm phải thu và dự thu cổ tức, tiền lãi các tài sản tài chính',
    IncreaseDecreaseInReceivableFromServicesRendered:
      '(-) Tăng, (+) giảm các khoản phải thu các dịch vụ CTCK cung cấp ',
    IncreaseDecreaseInReceibleFromTransactionErrors:
      '(-) Tăng, (+) giảm các khoản phải thu về lỗi giao dịch các TSTC',
    IncreaseDecreaseInOtherReceivables:
      '(-) Tăng, (+) giảm các khoản phải thu khác',
    IncreaseDecreaseInExpensePayableNotIncludingInterestExpense:
      '(-) Tăng, (+) giảm chi phí phải trả (không bao gồm chi phí lãi vay)',
    IncreaseDecreaseInTradePayables:
      '(+) Tăng, (-) giảm phải trả cho người bán',
    IncreaseDecreaseInPayablesToSecuritiesIssuers:
      '(+) Tăng, (-) giảm phải trả Tổ chức phát hành chứng khoán',
    IncreaseDecreaseInContributionToEmployeesWelfare:
      '(+) Tăng, (-) giảm các khoản trích nộp phúc lợi nhân viên',
    IncreaseDecreaseInTaxAndPayablesToAuthority:
      '(+) Tăng, (-) giảm thuế và các khoản phải nộp Nhà nước',
    IncreaseDecreaseInPayablesToEmployees:
      '(+) Tăng, (-) giảm phải trả người lao động',
    IncreaseDecreaseInPayableAriseFromFinancialAssetTransactionErrors:
      '(+) Tăng, (-) giảm phải trả về lỗi giao dịch các tài sản tài chính',
    IncreaseDecreaseInOtherPayable: '(+) Tăng, (-) giảm phải trả khác',
    IncreaseDecreaseInBusinessIncomeTaxPaid:
      '(+) Tăng, (-) giảm thuế TNDN CTCK đã nộp ',
    increaseDecreaseInInventories: 'Tăng/giảm hàng tồn kho',
    increaseDecreaseInPrepaidExpenses: 'Tăng/giảm chi phí trả trước',
    increaseDecreaseInTradingSecurities: 'Tăng/giảm chứng khoán kinh doanh',
    interestPaid: 'Tiền lãi vay đã trả',
    otherReceiptsFromOperatingActivities:
      'Tiền thu khác từ hoạt động kinh doanh',
    otherPaymentsOnOperatingActivities:
      'Tiền chi khác cho hoạt động kinh doanh',
    netCashInflowsoutflowsFromInvestingActivies:
      'Lưu chuyển từ hoạt động đầu tư',
    purchasesOfFixedAssetsAndOtherLongtermAssets:
      'Tiền chi để mua sắm, xây dựng TSCĐ và các tài sản dài hạn khác',
    ProceedsFromDisposalOfFixedAssets:
      'Tiền thu từ thanh lý, nhượng bán TSCĐ và các tài sản dài hạn khác',
    LoansGrantedPurchasesOfDebtInstruments:
      'Tiền chi cho vay, mua các công cụ nợ của đơn vị khác',
    collectionOfLoansProceedsFromSalesOfDebtsInstrument:
      'Tiền thu hồi cho vay, bán lại các công cụ nợ của đơn vị khác',
    InvestmentsInOtherEntities: 'Tiền chi đầu tư góp vốn vào đơn vị khác',
    ProceedsFromInvestmentInOtherEntities:
      'Tiền thu hồi đầu tư vào đơn vị khác',
    dividendsAndInterestReceived:
      'Tiền thu lãi cho vay, cổ tức và lợi nhuận được chia',
    netCashInflowsoutflowsFromFinancingActivities:
      'Lưu chuyển thuần từ hoạt động tài chính',
    proceedsFromIssueOfShares:
      'Tiền thu từ phát hành cổ phiếu, nhận vốn góp của chủ sở hữu',
    payMentsFroShareReturnsAndRepurchases:
      'Tiền chi trả vốn góp cho các chủ sở hữu, mua lại cổ phiếu của doanh nghiệp đã phát hành',
    proceedsFromLoans: 'Tiền vay ngắn hạn, dài hạn nhận được',
    loansFromSettlementAssistanceFundReceived:
      'Tiền vay Quỹ Hỗ trợ thanh toán ',
    otherLoansReceived: 'Tiền vay khác',
    repaymentOfLoans: 'Tiền chi trả nợ gốc vay',
    loansPrincipalRepaidToSettlementAssistanceFund:
      'Tiền chi trả gốc vay Quỹ Hỗ Trợ thanh toán',
    financialAssetsLoansPrincipalRepaid:
      'Tiền chi trả nợ gốc vay tài sản tài chính',
    otherLoansPrincipalRepaid: 'Tiền chi trả gốc nợ vay khác',
    financialLeasePricipalPayments: 'Tiền chi trả nợ thuê tài chính',
    dividensPaid: 'Cổ tức, lợi nhuận đã trả cho chủ sở hữ',
    netIncreaseInCashAndCashEquivalents: 'Lưu chuyển tiền thuần trong kỳ',
    cashAndCashEquivalentsAtTheBeginningOfPeriod:
      'Tiền và các khoản tương đương tiền đầu kỳ',
    cashAndBankDepositAtTheBeginningOfThePeriod:
      'Tiền mặt, tiền gửi ngân hàng đầu kỳ',
    cashEquivalents: 'Các khoản tương đương tiền',
    effectOfForeignExchangeDifferences:
      'Ảnh hưởng của thay đổi tỷ giá hối đoán quy đổi ngoại tệ',
    cashAndCashEquivalentsAtTheEndOfPeriod:
      'Tiền và các khoảng tương đương tiền cuối kỳ',
  },

  financialReportTitleTable: {
    reportName: 'Tên báo cáo',
    period: 'Kỳ báo cáo',
    download: 'Tải xuống',
  },

  financialReportDefaultYear: 'Tất cả',

  footerNote: 'Đơn vị: Tỷ VND',
  noData: 'Dữ liệu đang cập nhật',
};
